import $ from "jquery"
import "jquery-match-height";

$('.js-match-height-slider').matchHeight();
$('.js-stories-title').matchHeight();
$('.js-stories-content').matchHeight();
//$('.js-clients-matchheight').matchHeight();

$(window).on('load', function(){
    $('.js-match-height-slider').matchHeight();
    $('.js-stories-title').matchHeight();
    $('.js-stories-content').matchHeight();
    //$('.js-clients-matchheight').matchHeight();
});

$(window).on('resize', function(){
    setTimeout(function(){
        $('.js-match-height-slider').matchHeight();
        $('.js-stories-title').matchHeight();
        $('.js-stories-content').matchHeight();
        //$('.js-clients-matchheight').matchHeight();
    }, 500);
});